import React from "react";
import { Eye, EyeOff } from "lucide-react";
import { formatEUR } from "@/lib/format";

// Dettaglio liquidità per banca (deduplicato): totale + conti con toggle visibilità.
export const BankLiquidityBreakdown = ({ balances, showZero, setShowZero, accBusy, onToggleAccount }) => {
  if (!balances || !(balances.banks?.length > 0)) return null;
  return (
    <div className="mb-4 rounded-[12px] border border-white/[0.08] bg-[#0D0D14] p-4" data-testid="balance-breakdown">
      <div className="flex items-baseline justify-between">
        <span className="caps-tag text-white/40">Liquidità totale</span>
        {!balances.complete && (
          <span className="caps-tag text-[#FFD60A]/70">parziale</span>
        )}
      </div>
      <p className="mono mt-1 text-[30px] font-light tabular text-white" data-testid="breakdown-grand-total">
        {formatEUR(balances.grand_total)}
      </p>

      <div className="mt-3 space-y-3">
        {balances.banks.map((bank) => {
          const visibleAccts = bank.accounts.filter((a) => showZero || !a.zero || a.hidden);
          return (
            <div key={bank.institution_name}>
              <div className="flex items-center justify-between border-b border-white/[0.05] pb-1.5">
                <span className="text-[12px] font-medium text-white/70">{bank.institution_name}</span>
                <span className="mono text-[13px] tabular text-white/80" data-testid="breakdown-bank-subtotal">
                  {formatEUR(bank.subtotal)}
                </span>
              </div>
              <div className="mt-1">
                {visibleAccts.map((a) => (
                  <div
                    key={a.key}
                    className="flex items-center justify-between py-1.5"
                    data-testid="breakdown-account-row"
                  >
                    <div className="min-w-0 flex-1">
                      <p className={`truncate text-[12px] font-light ${a.hidden ? "text-white/35" : "text-white/75"}`}>
                        {a.name}
                        {a.iban_tail ? <span className="mono text-white/30"> ·••{a.iban_tail}</span> : null}
                      </p>
                      <div className="mt-0.5 flex flex-wrap gap-1.5">
                        {a.hidden && (
                          <span className="caps-tag rounded-[3px] border border-white/15 px-1 text-white/40">
                            esclusa dal totale
                          </span>
                        )}
                        {a.is_card && (
                          <span className="caps-tag rounded-[3px] border border-[#FFD60A]/30 px-1 text-[#FFD60A]/70">
                            carta
                          </span>
                        )}
                        {a.duplicates > 0 && (
                          <span className="caps-tag rounded-[3px] border border-white/10 px-1 text-white/30">
                            {a.duplicates} doppioni uniti
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex shrink-0 items-center gap-2">
                      <span className={`mono text-[13px] tabular ${a.hidden ? "text-white/30 line-through" : "text-white/85"}`}>
                        {formatEUR(a.balance)}
                      </span>
                      <button
                        onClick={() => onToggleAccount(a)}
                        disabled={accBusy === a.key}
                        data-testid="breakdown-toggle-account"
                        aria-label={a.hidden ? "Includi nel totale" : "Escludi dal totale"}
                        className="flex h-7 w-7 items-center justify-center rounded-[5px] border border-white/[0.1] text-white/45 hover:bg-white/[0.05] hover:text-white/80 active:scale-[0.95] disabled:opacity-40"
                      >
                        {a.hidden ? <EyeOff size={12} /> : <Eye size={12} />}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {balances.paypal != null && (
          <div className="flex items-center justify-between border-t border-white/[0.05] pt-2">
            <span className="text-[12px] font-medium text-white/70">PayPal</span>
            <span className="mono text-[13px] tabular text-white/80">{formatEUR(balances.paypal)}</span>
          </div>
        )}
      </div>

      <button
        onClick={() => setShowZero((v) => !v)}
        data-testid="breakdown-toggle-zero"
        className="mono mt-3 w-full text-center text-[10px] uppercase tracking-[0.12em] text-white/35 hover:text-white/60"
      >
        {showZero ? "Nascondi conti a 0" : "Mostra conti a 0"}
      </button>
    </div>
  );
};
